import React from 'react';
import ProductCard from './ProductCard';

const Products = ({ products = [], onAddToCart, onItemClick, cartList = [] }) => {
    return (
        <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            padding: '2px',
            backgroundColor: '#FBFBFC'
        }}>

            <br/>
            <div style={{ width: '100%', textAlign: 'center' }}>
             </div>
            <br/>

            {products.map((product) => (
                <ProductCard 
                    key={product.id}
                    product={product}
                    onAddToCart={onAddToCart}
                    onItemClick={onItemClick}
                    cartList={cartList}
                />
            ))}
        </div>
    );
};

export default Products;
